import gallery1Img from "../assets/images/gallery-images/Impact_story_photo_KQE.jpg";
import gallery4Img from "../assets/images/gallery-images/story-gallery-img4.png";
import S3CLink from "../components/S3CLink";

const galleryList = [
  {
    id: 0,
    caption: (
        <p>
        <span className='gallery-caption'>Photo: New mom with her newborn receiving care from a healthcare provider </span> 
        <strong className='gallery-coalition-title'>Launching a Newborn Intensive Care Unit</strong>
        After months of data-driven advocacy efforts to elevate insights from PULSE dashboards, Mombasa County launched a Level 4 Newborn Intensive Care Unit (NBU) at Port Reitz to improve access to emergency newborn support. Through the data dashboards, KQE was able to identify and communicate the gaps in the county’s newborn care provision. The insights demonstrated the necessary components (staffing, training) needed for the NBU and its potential impact on newborn outcomes. It is anticipated that the NBU will provide specialist support for ~120 newborns annually over the coming years and contribute to a reduction in the county’s high infant mortality rate (30.5/1000 in Mombasa vs. national average 21/1000).
      </p>
    ),
    image: gallery1Img
  },
  {
    id: 1,
    caption: (
        <p>
        <span className='gallery-caption'>Photo: Health care Worker introducing PROMPTS to a patient </span> 
        <strong className='gallery-coalition-title'>Technology that Empowers Mothers through Pregnancy</strong>
        A pregnant woman signed up for Jacaranda’s digital health tool PROMPTS during a routine visit to the Makueni Sub County Referral Hospital. As a first-time mother, she was relieved to start receiving messages to guide her through her pregnancy journey – messages helping her eat a balanced diet and, importantly, reminders for when to visit a facility for her prenatal care check-ups. When her baby boy was born, she found PROMPTS carried her through the daunting stages of newborn care and breastfeeding and helped her navigate the nuanced world of family planning – something no one had spoken with her about previously.
      </p>
    ),
    image: gallery4Img
  }
];

export default galleryList;
